// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-2O7","toggle":"styles_toggle__3Fo1D","preview":"styles_preview__2QJ9i"};